module.exports = __webpack_public_path__ + "img/search_icon.49b7bc49.svg";